import { createMuiTheme } from '@material-ui/core/styles'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#00a5b8',
      contrastText: '#fff',
    },
  },
})

export default theme
